<template>
  <div >
    <container></container>
  </div>
</template>
<script>
import container from './components/container.vue'
export default {
  components: {
    container
  }
}
</script>
